import * as net from 'util/Net';
import {
  StageConfiguration,
  StageFlowNode,
  StageRun,
  WorkflowTemplateVersionDetails,
} from 'workflows/WorkflowConstants';

interface EditStageFlowNodeResponse {
  stageFlowNode: StageFlowNode;
  stageRun: StageRun | null;
}

export function editStageFlowNode(
  stageFlowNodeId: string,
  {
    parentIds,
    experimentalConditionValueIds,
  }: {
    parentIds: Array<string> | undefined;
    experimentalConditionValueIds?: Array<string>;
  }
): JQueryPromise<EditStageFlowNodeResponse> {
  return net.patchJSON({
    url: `/1/api/workflows/stage-flow-nodes/${stageFlowNodeId}`,
    data: {parentIds, experimentalConditionValueIds},
  });
}

export function deleteStageFlowNode(
  stageFlowNodeId: string,
  {shouldDeleteDownstreamNodes}: {shouldDeleteDownstreamNodes: boolean}
): JQueryPromise<WorkflowTemplateVersionDetails> {
  return net.delete_({
    url: `/1/api/workflows/stage-flow-nodes/${stageFlowNodeId}`,
    data: {shouldDeleteDownstreamNodes},
  });
}

interface CreateStageFlowNodeResponse {
  stageFlowNode: StageFlowNode;
  stageConfiguration: StageConfiguration;
}

export function createStageFlowNode({
  stageConfigurationId,
  parentIds,
}: {
  stageConfigurationId: string;
  parentIds: Array<string>;
}): JQueryPromise<CreateStageFlowNodeResponse> {
  return net.postJSON({
    url: '/1/api/workflows/stage-flow-nodes',
    data: {stageConfigurationId, parentIds},
  });
}

export function duplicateStageFlowNodeTree({
  stageFlowNodeId,
}: {
  stageFlowNodeId: string;
}): JQueryPromise<WorkflowTemplateVersionDetails> {
  return net.postJSON({
    url: `/1/api/workflows/stage-flow-nodes/${stageFlowNodeId}:duplicate`,
  });
}

export function explodeStageFlowNodeTree({
  stageFlowNodeId,
}: {
  stageFlowNodeId: string;
}): JQueryPromise<WorkflowTemplateVersionDetails> {
  return net.postJSON({
    url: `/1/api/workflows/stage-flow-nodes/${stageFlowNodeId}:explode`,
  });
}
